<template>
  <CrudList
    title="Anuncios App"
    storeName="App_ads"
    labelAddNew="Agregar"
    slot-scope="{ item }"
    sortable
    canSearch
    next-link="/admin/spot_helps"
    :breadcrumbs="[
        {
          text: 'Marketing y comunicación',
          disabled: false,
          href: '/admin/app_ads'
        },
        {
          text: 'Anuncios App',
          disabled: false,
          href: '#'
        }
      ]"
  >
  <template v-slot:hidden="{ item }">
      <v-row align="center" justify="center">
        <v-col cols="12">
          <v-switch
              ref="hiddenSwitch"
              :input-value="item.hidden" 
              color="primary"
              class="mt-n1 custom-purple"
              @change="updateHiddenStatus(item, $event)"
              ></v-switch>
        </v-col>
      </v-row>
    </template>
  </CrudList>
</template>

<script>
import CrudList from "@/components/Crud/CrudList";

export default {
  components: { CrudList },
  data() {
    return {
      data: {
        hidden:false
      },
    };
  },
  methods:{
    async updateHiddenStatus(item,value) {
      const {id,message,hidden}=item;
      let saveUrl =`App_ads/updateItem`;
      await  this.$store
          .dispatch(saveUrl, {id,message,hidden:value})
    }
  }
};
</script>
